import React from 'react';
import './About.css';
import image from '../../images/about.png';

const About = () => {
        return (
                <div className="mt-5 pt-5 brand-bg pb-5">
                        <div className="container">
                                <div className="about row mt-5">
                                        <div className="col-md-6 p-5">
                                                <img src={image} className="img-fluid  rounded-3" alt="" />
                                        </div>
                                        <div className="col-md-6 p-5">
                                                <h2 className="brand-color">About Us</h2>
                                                <p className="text-white w-75">
                                                        MacBook Pro. Our most powerful notebooks. Fast M1 processors, incredible graphics, and spectacular Retina displays. Now available in a 14-inch model.
                                                </p>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default About;